export enum Status {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
